import React, { FC } from "react";
import SelectAutocomplete from "app/component/autocomplete/SelectAutocomplete";
import Select, { SelectOptionType } from "app/component/select/Select";

interface Props {
  name: string;
  options: SelectOptionType[];
  handleChange: (option: any) => Promise<void>;
  defaultValue: SelectOptionType | null | undefined;
  defaultText?: string;
  readOnly?: boolean;
  disabled?: boolean;
  isWidget?: boolean;
  tabIndex: 0 | -1 | undefined;
  keyId?: string;
  autocomplete?: boolean;
}

const CustomPropertySelect: FC<Props> = ({
  isWidget = false,
  options,
  handleChange,
  name,
  defaultValue,
  defaultText,
  readOnly = false,
  disabled = false,
  tabIndex,
  keyId = name,
  autocomplete = false,
}) => {
  return (
    <>
      {autocomplete ? (
        <SelectAutocomplete
          key={"sa" + keyId}
          name={name}
          options={options}
          defaultValue={defaultValue}
          defaultText={defaultText}
          onChoose={handleChange}
          readOnly={readOnly}
          disabled={disabled}
          tabIndex={tabIndex}
          isWidget={isWidget}
        />
      ) : (
        <Select
          key={"s" + keyId}
          options={options}
          defaultValue={defaultValue}
		  defaultText={defaultText}
          onChoose={handleChange}
          readOnly={readOnly}
          disabled={disabled}
          isWidget={isWidget}
        />
	  )}
    </>
  );
};

export default CustomPropertySelect;
